module.exports = __webpack_public_path__ + "media/07_ASANBUDAPEST-BASS07.da60c55d.mp3";